import React from 'react'
import { Regulation, Pdf } from '../styles.style'
import ReactHtmlParser from 'react-html-parser'

const RegulationComponent = ({ regulation }) => {
	return (
		<Regulation>
			<h2 className="regulation-title">Regulamento</h2>
			<Pdf>{ReactHtmlParser(regulation)}</Pdf>
		</Regulation>
	)
}

export default RegulationComponent
